// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{.dispatch-thumb{border-bottom:5px solid #666}}\n", ""]);
// Exports
module.exports = exports;
